import { ListItemProps } from '@silverfort/sf-components/dist/ListItem';

export const ResourceTypeOptions: Array<ListItemProps<string>> = [
    { title: 'All', value: '' },
    { title: 'Hostname', value: 'hostname' },
    { title: 'IP', value: 'ip' },
];
